import {Component, Inject, OnDestroy, OnInit} from "@angular/core";
import RegroupementPlatDTO from "../../../../core/dtos/conditionnement/regroupement-plat-d-t-o";
import {Auth2Service} from "../../../../core/services/security/auth2.service";
import {
  RegroupementPlatService
} from "../../../../core/services/conditionnements/regroupement/regroupement-plat.service";
import {ProduitDTO} from "../../../../core/dtos/produit-dto";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../../core/utils/utils.service";
import {confirm} from "devextreme/ui/dialog";


@Component({
  selector: 'yo-regroupement-plat-dialog-plat',
  templateUrl: './regroupement-plat-dialog-plats.component.html',
  styleUrls: ['./regroupement-plat-dialog-plats.component.scss']
})

export class RegroupementPlatDialogPlatsComponent implements OnInit, OnDestroy{

  platList: ProduitDTO[] = [];
  selectedRows: number[] = [];
  private subPlatList: Subscription;
  private subAddPlat: Subscription;

  constructor(@Inject('dynamicData') public regroupementPlat: RegroupementPlatDTO,
              private regroupementSvc: RegroupementPlatService,
              private toastSvc: ToastService,
              private authSvc: Auth2Service,
              private utilSvc: UtilsService) {
  }

  ngOnInit() {
    this.initPlatList()
    this.initSubAddPlat();
  }

  ngOnDestroy() {
    this.utilSvc.unsubscribe(this.subPlatList);
    this.utilSvc.unsubscribe(this.subAddPlat);
  }


  deleteValues = async (): Promise<void> =>  {
    const result = confirm('Êtes-vous sûr de vouloir supprimer le(s) plats sélectionné(s) ?', 'Suppression');
    const isDeleted: boolean = await result;
    if(isDeleted) {
      this.selectedRows.map(id => this.platList.find(plat => plat.id === id));
      this.regroupementSvc.deletePlat(this.selectedRows, this.regroupementPlat.id).subscribe((res) => {
        if (res.one) {
          if (res.one.updateError) {
            this.regroupementSvc.announceErreurParametrage(res.one.erreurs)
          } else {
            this.platList = this.platList.filter(p => !this.selectedRows.includes(p.id));
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Plat(s) supprimé(s) avec succès`);
            this.regroupementPlat.plats = this.platList
          }
        }
      });
    }
  }

  canEdit() {
    return this.authSvc.isSiteLocal(this.regroupementPlat.site.id);
  }

  openDialogAjoutPlats() {
    this.regroupementSvc.announceOpenAjoutPlat(this.regroupementPlat);
  }

  private initPlatList() {
    this.subPlatList = this.regroupementSvc.getPlats(this.regroupementPlat.id).subscribe((res) => {
      if (res) {
        this.platList = res.resultList;
        this.regroupementPlat.plats = res.resultList
      }
    })
  }

  private initSubAddPlat() {
    this.subAddPlat = this.regroupementSvc.subjectRegroupementAddPlats$.subscribe((res: ProduitDTO[]) => {
      this.regroupementPlat.plats = res;
      console.log(this.regroupementPlat)
      this.platList.push(...res)
    })
  }

}
